/**
 * Enum de steps do formulário de criação de agenda.
 *
 * S0AttendanceType: escolha do tipo de atendimento (1ª tela)
 * S1Location: seleção/criação de localização (só para presencial)
 * S2HealthCare: serviço de saúde e horários disponíveis
 * S3TimeAvailable: configurações da agenda (nome, datas, duração)
 * S4ConfirmationScreen: revisão final e confirmação
 */
export enum Steps {
  S0AttendanceType,
  S1Location,
  S2HealthCare,
  S3TimeAvailable,
  S4ConfirmationScreen,
}

/**
 * Tipos de atendimento disponíveis para uma agenda.
 *
 * - presencial: atendimento físico com localização de endereço
 * - teleatendimento: consulta por vídeo (1 localização por organização)
 * - chat: atendimento por mensagens (1 localização por organização)
 * - domicilio: visita domiciliar (endereço configurado depois)
 */
export type AttendanceType =
  | "presencial"
  | "teleatendimento"
  | "chat"
  | "domicilio";

/**
 * Label amigável para exibição de cada tipo de atendimento.
 */
export const ATTENDANCE_TYPE_LABEL: Record<AttendanceType, string> = {
  presencial: "Presencial",
  teleatendimento: "Teleatendimento",
  chat: "Chat",
  domicilio: "Atendimento a Domicílio",
};
